import React, { useEffect, useState } from 'react'
import { Helmet } from "react-helmet";
import { useNavigate } from 'react-router-dom';
import useBookingPage from 'services/store/BookingPage';
import { useSearchParams } from "react-router-dom";
import useLoadedStore from 'services/store/LoadedPage';
import liff from "@line/liff";
import axios from "axios";
import ModalTerms from 'components/modal/ModalTerms';
import ModalPrivacy from 'components/modal/ModalPrivacy';
import { submitBnaProgram } from "../../services/Api/Module/bnaProgram";

const EventPolicy2 = () => {
    useLoadedStore();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { profile } = useBookingPage();
    const [lineId, setLineId] = useState(null);
    const [isOpenNoLink, setIsOpenNoLink] = useState(false);
    const [checkbox1, setCheckbox1] = useState(false);
    const [checkbox2, setCheckbox2] = useState(false);
    const [showTermsModal, setShowTermsModal] = useState(false);
    const [showPrivacyModal, setShowPrivacyModal] = useState(false);
    const [resultCode, setResultCode] = useState(null); // เพิ่ม state สำหรับเก็บ resultCode
    const userToken = window.localStorage.getItem('userToken');
    const qToken = searchParams.get('token') ?? userToken;
    window.localStorage.setItem('userToken', qToken);
    const [isSuccess, setIsSuccess] = useState(false);

    useEffect(() => {
        getLineLiff();

    }, []);

    const checkBna = async (lineId) => {
        try {
            // ตรวจสอบว่ามี bna parameter หรือไม่
            const bnaParam = searchParams.get('bna');
            if (!bnaParam) {
                alert('ไม่พบข้อมูล BNA กรุณาเข้าถึงหน้านี้ผ่านหน้า EventPolicy2');
                return;
            }
            // เตรียมข้อมูลสำหรับส่งไป API
            const submitData = {
                lineUID: lineId,
            };
            // เรียก API submitBnaProgram
            const response = await submitBnaProgram({ data: submitData });
            // เก็บค่า resultCode ไว้ใน state
            setResultCode(response.data.resultCode);

            if (+response.data.resultCode === 20000) {
                setIsSuccess(true);
            } else {
                navigate('/bna-program-recieved');
            }
        } catch (error) {
            alert('เกิดข้อผิดพลาดในการบันทึกข้อมูล กรุณาลองใหม่อีกครั้ง');
        }
    };

    const getLineLiff = async () => {
        await liff.init({ liffId: "1653772966-xj3r3qW3" })
        if (liff.isInClient()) {
            const _lineId = liff.getDecodedIDToken()?.sub
            setLineId(_lineId);
            checkBna(_lineId);
        } else {
            if (liff.isLoggedIn()) {
                const _lineId = liff.getDecodedIDToken()?.sub
                setLineId(_lineId);
                checkBna(_lineId);
            } else {
                liff.login({ redirectUri: window.location.href })
            }
        }

    }

    const handleCheckbox1Change = () => {
        setCheckbox1(!checkbox1);
    };

    const handleCheckbox2Change = () => {
        setCheckbox2(!checkbox2);
    };

    const openTermsModal = (e) => {
        e.preventDefault();
        setShowTermsModal(true);
    };

    const closeTermsModal = () => {
        setShowTermsModal(false);
    };

    const openPrivacyModal = (e) => {
        e.preventDefault();
        setShowPrivacyModal(true);
    };

    const closePrivacyModal = () => {
        setShowPrivacyModal(false);
    };

    const handleConfirm = () => {
        if (checkbox1 && checkbox2) {
            // ทำการยืนยัน

            // ดึงค่า bna จาก URL search params
            const bnaParam = searchParams.get('bna');

            // ส่ง state bna ไปกับ navigate
            navigate('/bna-program', {
                state: {
                    bna: bnaParam
                }
            });

        }
    };

    const isConfirmEnabled = checkbox1 && checkbox2;


    return (
        <div>
            <Helmet>
                <title>S-Mom</title>
                <meta name="title" content="S-Mom" />
                <meta name="description" content="" />
                <meta name="keyword" content="" />
                <meta property="og:title" content="" />
                <meta property="og:description" content="" />
                <meta property="og:image" content="" />
                <meta property="og:url" content="" />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="" />
            </Helmet>
            {/* แสดง div เฉพาะเมื่อ resultCode === 20000 */}
            {isSuccess && (
                <div id="pageEventPolicy2">
                    <main>
                        {/* Logo */}
                        <div className="event-policy-logo">
                            <div className="event-policy-logo-image"></div>
                        </div>

                        {/* Title */}
                        <h1 className="event-policy-title">
                            ข้อกำหนดและความเป็นส่วนตัว
                        </h1>

                        <div className="event-policy-container">
                            {/* First checkbox */}
                            <div className="event-policy-checkbox-group">
                                <input
                                    type="checkbox"
                                    checked={checkbox1}
                                    onChange={handleCheckbox1Change}
                                    className="event-policy-checkbox"
                                />
                                <div className="event-policy-text">
                                    ฉันยอมรับ
                                    <a href="javascript:void(0)" className="event-policy-link" onClick={openTermsModal}>
                                        ข้อกำหนดและเงื่อนไขของบริการ
                                    </a>
                                </div>
                            </div>

                            {/* Second checkbox */}
                            <div className="event-policy-checkbox-group">
                                <input
                                    type="checkbox"
                                    checked={checkbox2}
                                    onChange={handleCheckbox2Change}
                                    className="event-policy-checkbox"
                                />
                                <div className="event-policy-text">
                                    ฉันยินยอมให้ Nestl<span className="consent-e">é</span> (Thai) Ltd. และบริษัทในเครือภายในกลุ่มของ Nestl<span className="consent-e">é</span> (Thai) Ltd. (“Nestl<span className="consent-e">é</span>”) เก็บรวบรวม ใช้ และ/หรือ เปิดเผยข้อมูลส่วนบุคคลของฉันเพื่อวัตถุประสงค์ ในการทำการตลาด การโฆษณา การเสนอขายสินค้าหรือบริการที่เกี่ยวข้อง รวมถึงการให้ข้อมูล ข้อเสนอ และสิทธิประโยชน์อื่น ๆ แก่ฉัน
                                    <br />
                                    <br />
                                    โดยการให้ความยินยอมในการทำการตลาดนี้ ฉันยืนยันว่าฉันมีอายุอย่างน้อย 20 ปี หากฉันเป็นผู้เยาว์ (อายุเกิน 10 ปีและต่ำกว่า 20 ปี) ฉันรับทราบว่าจำเป็นต้องได้รับความยินยอมจากทั้งผู้ปกครองหรือผู้ดูแลของฉันและจากตัวฉันเอง
                                    <br />
                                    <br />
                                    คุณมีสิทธิ์ที่จะถอนความยินยอมของคุณ สำหรับข้อมูลเพิ่มเติม กรุณาศึกษาที่
                                    <a href="javascript:void(0)" className="event-policy-link" onClick={openPrivacyModal}>
                                        นโยบายความเป็นส่วนตัวของ Nestl<span className="consent-e">é</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </main>

                    {/* Confirm Button */}
                    <div className="event-policy-confirm-button-container">
                        <button
                            className={`event-policy-confirm-button ${isConfirmEnabled ? 'enabled' : 'disabled'}`}
                            onClick={handleConfirm}
                            disabled={!isConfirmEnabled}
                        >
                            ยืนยัน
                        </button>
                    </div>
                </div>
            )}

            {/* Modal Components */}
            <ModalTerms
                open={showTermsModal}
                onClose={closeTermsModal}
            />

            <ModalPrivacy
                open={showPrivacyModal}
                onClose={closePrivacyModal}
            />
        </div>
    )
}

export default EventPolicy2